import { trackEvent } from '@argonaut/analytics';

export default {
  trackEvent,
};
